import { z } from 'zod';

const nullableNonNegativeInteger = z
  .number()
  .int()
  .nonnegative()
  .max(Number.MAX_SAFE_INTEGER)
  .nullable()
  .default(null);

/**
 * 计量账本只接受结构化的数值维度；请求正文、响应正文和 provider 原始诊断不属于账本。
 * 字段保持可空，避免把 provider 未提供的维度伪装成零。
 */
export const AiUsageLedgerDimensionsSchema = z
  .object({
    output_units: nullableNonNegativeInteger,
    input_tokens: nullableNonNegativeInteger,
    output_tokens: nullableNonNegativeInteger,
    cached_tokens: nullableNonNegativeInteger,
    reasoning_tokens: nullableNonNegativeInteger,
    total_tokens: nullableNonNegativeInteger,
    image_input_units: nullableNonNegativeInteger,
    image_output_units: nullableNonNegativeInteger,
    audio_input_units: nullableNonNegativeInteger,
    audio_output_units: nullableNonNegativeInteger,
    tool_calls: nullableNonNegativeInteger,
  })
  .strict();

export type AiUsageLedgerDimensions = z.output<typeof AiUsageLedgerDimensionsSchema>;
export type AiUsageLedgerDimensionsInput = z.input<typeof AiUsageLedgerDimensionsSchema>;

export function normalizeAiUsageLedgerDimensions(value: unknown): AiUsageLedgerDimensions {
  return AiUsageLedgerDimensionsSchema.parse(value ?? {});
}
